import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AttendanceRecording from "./components/AttendanceRecording";
import AttendanceCalculation from "./components/AttendanceCalculation";
import AttendanceCategoriesV2 from "./components/AttendanceCategoriesV2";
import AttendanceSettingsSetupGuide from "./components/AttendanceSettingsSetupGuide";
import ExcusalSettings from "./components/ExcusalSettings";
import AttendanceTiers from "./components/AttendanceTiers";

export default store => ({
  path: "attendance-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import("./components"),
      import("./modules/AttendanceSettingsV2Module"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "attendanceSettingsV2",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [
    AttendanceCalculation(store),
    AttendanceRecording(store),
    AttendanceSettingsSetupGuide(store),
    AttendanceCategoriesV2(store),
    ExcusalSettings(store),
    AttendanceTiers(store),
  ],
});
